import { uuid } from "../uuid";

export const mixerPipeId = uuid;
